<template>
  <qrcode-vue :value="value" :size="size" level="H" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import QrcodeVue from "qrcode.vue";

export default defineComponent({
  name: "QRCodeGenerator",
  components: {
    QrcodeVue,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 100,
    },
  },
});
</script>
